// src/components/InviteCodeInputCard.tsx
import { useState } from "react";

type Props = {
  onSubmit: (code: string) => void;
  onCancel: () => void;
  error?: string | null;
  loading?: boolean;
};

// 招待コードは大文字英数字 8 文字（紛らわしい文字 0/O/1/I/l はサーバー側で除外済み）
const INVITE_CODE_RE = /^[A-Z0-9]{8}$/;

function normalizeInviteCode(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
}

export function InviteCodeInputCard({ onSubmit, onCancel, error, loading = false }: Props) {
  const [code, setCode] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(normalizeInviteCode(e.target.value));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!INVITE_CODE_RE.test(code) || loading) return;
    onSubmit(code);
  };

  return (
    <div className="mt-10">
      <p className="text-sm font-bold text-[#5D4D46]">招待コードを入力してください</p>
      <p className="mt-1 text-xs text-[#9C867D]">招待コードは大文字英数字8文字です</p>

      <form onSubmit={handleSubmit} className="mt-4">
        <input
          type="text"
          value={code}
          onChange={handleChange}
          maxLength={8}
          placeholder="XXXXXXXX"
          autoFocus
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="characters"
          spellCheck={false}
          disabled={loading}
          className="w-full rounded-2xl border border-[#EADBC8] bg-white px-4 py-3 text-center font-mono text-lg tracking-[0.25em] text-[#4A3E39] placeholder-[#C9B8AF] outline-none focus:border-[#A67C52] focus:ring-2 focus:ring-[#A67C52]/20 disabled:opacity-50"
        />

        {error && (
          <p className="mt-3 rounded-2xl border border-[#E8B2A8] bg-[#FFF3F1] px-4 py-3 text-xs font-medium text-[#A1493E]">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={!INVITE_CODE_RE.test(code) || loading}
          className="mt-4 w-full rounded-2xl bg-[#A67C52] px-4 py-3 text-sm font-bold text-white shadow-sm hover:bg-[#8C6540] active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "確認中..." : "登録する"}
        </button>
      </form>

      <button
        type="button"
        onClick={onCancel}
        disabled={loading}
        className="mt-4 w-full text-xs text-[#9C867D] hover:text-[#7B6861] disabled:opacity-50"
      >
        別のアカウントでサインイン
      </button>
    </div>
  );
}
